import { useMemo } from "react";
import { useIntl } from "react-intl";
export var useAgencyPrefixTable = function (onRowClick) {
    var formatMessage = useIntl().formatMessage;
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-agency.agency-prefix.table.columns.agency",
            }),
            key: "id",
            cellRenderer: function (item) { var _a; return (_a = item.internationalPrefix.agency) !== null && _a !== void 0 ? _a : "N/A"; },
            clickable: true,
            onClick: onRowClick,
        },
        {
            name: formatMessage({
                id: "ui-br-agency.agency-prefix.table.columns.internationalPrefix",
            }),
            key: "internationalPrefix",
            cellRenderer: function (item) { var _a; return (_a = item.internationalPrefix.value) !== null && _a !== void 0 ? _a : "N/A"; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.agency-prefix.table.columns.value",
            }),
            key: "value",
            cellRenderer: function (item) { var _a; return (_a = item.value) !== null && _a !== void 0 ? _a : "N/A"; },
        },
    ]; }, [formatMessage, onRowClick]);
    return { columns: columns };
};
